import { CardNumberConfig } from 'typings/brands'

/**
 * This is temporary configuration for card number length. Need to update it
 * once the client is eligible for card activation feature
 */
export const cardNumberConfig: CardNumberConfig = {
  length: [16, 16]
}
